import React, { useEffect, useState } from "react";
import { useAppHookContext } from '@nkr/utils/rest-api';
import { RouteComponentProps, withRouter } from 'react-router';
import { Col, Nav, NavItem, Row } from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap';
import StrongBoxCenters from "./strong-box-centers";
import StrongBoxOpos from '../strong-box-opo/strong-box-opos';
import StrongBoxOrders from "./strong-box-orders";
import StrongBoxOpoOrders from "../strong-box-opo/strong-box-opo-orders";
import StrongBoxUsage from "./strong-box-usage";
import StrongBoxOpoUsage from "../strong-box-opo/strong-box-opo-usage";
import PhysicalInventory from "./physical-inventory";
import PhysicalInventoryOpo from "../strong-box-opo/physical-inventory-opo";
import styled from 'styled-components';

const NavWrapper = styled(Nav)`
    & > li > a {
        padding: 5px 7.5px;
    }
`;

interface IProps extends RouteComponentProps {
    tabKey: number,
    isOpo: boolean
}

const StrongBoxListing = ({ tabKey, isOpo, match }: IProps) => {
    const { app: { user } } = useAppHookContext();

    enum StrongBoxTab {
        InventoryPerEntity = 0,
        OrderHistory,
        UsageHistory,
        InventoryReports
    }

    interface IStrongBoxTab {
        key: StrongBoxTab,
        title: string,
        component: JSX.Element,
        url: string
    }

    const tabs: IStrongBoxTab[] = [
        { key: StrongBoxTab.InventoryPerEntity, title: 'Inventory', component: !isOpo ? <StrongBoxCenters /> : <StrongBoxOpos />, url: '/inventory' },
        { key: StrongBoxTab.OrderHistory, title: 'Order History', component: !isOpo ? <StrongBoxOrders /> : <StrongBoxOpoOrders />, url: '/orders' },
        { key: StrongBoxTab.UsageHistory, title: 'Usage History', component: !isOpo ? <StrongBoxUsage /> : <StrongBoxOpoUsage />, url: '/usage-history' },
        { key: StrongBoxTab.InventoryReports, title: 'Inventory Reports', component: !isOpo ? <PhysicalInventory /> : <PhysicalInventoryOpo />, url: '/inventory-reports' },
    ];

    const getBaseUrl = () => {
        let baseUrl = !isOpo ? '/strongbox/listing' : '/strongbox-opo/listing';

        if (user.opoId) {
            baseUrl = '/opo/strongbox';
        }

        return baseUrl;
    };

    const baseUrl = getBaseUrl();

    const tab = tabs[tabKey];

    return (
        <>
            <Row>
                <Col sm={12}><h4 style={{ marginTop: 10, marginBottom: 20 }}>StrongBox Inventory Tracking</h4></Col>
            </Row>

            {!user.opoId && (
                <Row>
                    <Col sm={12}>
                        <Nav bsStyle='tabs' activeKey={!isOpo ? 'center' : 'opo'}>
                            <NavItem eventKey='center' href='/strongbox/listing/inventory'>Center</NavItem>
                            <NavItem eventKey='opo' href='/strongbox-opo/listing/inventory'>OPO</NavItem>
                        </Nav>
                    </Col>
                </Row>
            )}

            <Row>
                <Col sm={6} style={{ paddingTop: 10 }}>
                    <NavWrapper bsStyle="pills" activeKey={tabKey}>
                        {tabs.map(t => <LinkContainer to={baseUrl + t.url}><NavItem key={t.key} href={baseUrl + t.url}>{t.title}</NavItem></LinkContainer>)}
                    </NavWrapper>
                </Col>
                <Col sm={6}></Col>
            </Row>
            <Row>
                <Col xs={12} style={{ paddingTop: 10 }}>
                    {tab.component}
                </Col>
            </Row>
        </>
    );
}

export default withRouter(StrongBoxListing);